export const ADD_MENTOR_DATA = "ADD_MENTOR_DATA";
export const ADD_PROFILE_ID = "ADD_PROFILE_ID";
export const ADD_ALUMNI_INFO = "ADD_ALUMNI_INFO";
export const ADD_WEBINAR = "ADD_WEBINAR";
export const CLEAR_CONNECT  = "CLEAR_CONNECT";

export const addMentorInfo = (data) => {
  return {
    type: ADD_MENTOR_DATA,
    data,
  };
};
export const addAlumniInfo = (data) => {
  return {
    type: ADD_ALUMNI_INFO,
    data,
  };
};
export const addWebinar = (data) => {
  return {
    type: ADD_WEBINAR,
    data,
  };
};
export const addProfileId = (data) => {
  return {
    type: ADD_PROFILE_ID,
    data,
  };
};

export const resetClear = () => {
  return {
    type: CLEAR_CONNECT,
    
  };
};


